var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge p-2 fontsize-mini",style:(`background: ${_vm.getStatusColor(_vm.status)}; color:${_vm.$root.dynamicColor(_vm.status)}`)},[_vm._v(" "+_vm._s(_vm.getOrderStatus(_vm.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }